import { Component, Vue } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";

export const GET_MARKET_SEGMENTS = "get_market_segments";

@Component
export default class MarketSegmentsMixin extends Vue {
  index() {
    const path = `${API_ENDPOINT}/special_initiatives/market_segments.json`;
    return this.$store.dispatch("http/request", {
      tag: GET_MARKET_SEGMENTS,
      url: path,
      method: "GET",
    });
  }
}
